/**
 * Console display for use in the Iris environment.
 */
import React from 'react';
import ConsoleHistoryItem from "./ConsoleHistoryItem.js";
import "./ConsoleHistory.css";
import { jsx as _jsx } from "react/jsx-runtime";
function itemKey(i, item) {
  return "".concat(i, ".").concat(item.command, ".").concat(item.result && item.result.message, ".").concat(item.result && item.result.error);
}

/**
 * Display the console history.
 */
var ConsoleHistory = /*#__PURE__*/React.forwardRef(function ConsoleHistory(props, ref) {
  var _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    items = props.items,
    language = props.language,
    openObject = props.openObject,
    supportsType = props.supportsType,
    iconForType = props.iconForType,
    onCommandSubmit = props.onCommandSubmit;
  var historyElements = [];
  for (var i = 0; i < items.length; i += 1) {
    var item = items[i];
    var historyElement = /*#__PURE__*/_jsx(ConsoleHistoryItem, {
      disabled: disabled,
      item: item,
      openObject: openObject,
      language: language,
      supportsType: supportsType,
      iconForType: iconForType,
      onCommandSubmit: onCommandSubmit
    }, itemKey(i, item));
    historyElements.push(historyElement);
  }
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    className: "container-fluid console-history",
    children: historyElements
  });
});
export default ConsoleHistory;
//# sourceMappingURL=ConsoleHistory.js.map